export default {
  allDay: 'Hela dagen',
  add: 'Lägg till',
  added: 'Skapade',
  addMore: 'En till',
  areYouSure: 'Är du säker?',
  cancel: 'Avbryt',
  cancelHabit: 'Sluta repetera',
  changesToSync: 'ändringar att synka',
  clear: 'Rensa',
  confirm: 'Bekräfta',
  confirmExactTime: 'Bekräfta',
  copied: 'Lägg till kopierat innehåll i listan?',
  custom: 'Konfigurera',
  email: 'E-post',
  every: 'Varje',
  everyMonth: 'varje månad',
  everyYear: 'varje år',
  gotcha: 'Jag fattar',
  habit: 'Repetera',
  inOneMonth: 'Om en månad',
  iWouldLikeToBeAbleTo: 'Jag skulle vilja kunna..',
  justSwipe: 'Det är bara att svepa',
  laterToday: 'Senare',
  leaveFeedback: 'Lämna synpunkter',
  likeItRateIt: 'Gillar du appen? Ge ett betyg!',
  listname_deleted: 'Raderade uppgifter',
  listname_done: 'Klarmarkerade uppgifter',
  listname_postponed: 'Senare',
  listname_todo: 'Att göra',
  login: 'Anslut',
  loginNow: 'Anslut nu',
  loginOrSignup: 'Logga in eller registrera dig',
  loginToSync: 'Anslut din epost för att synka med fler enheter',
  logMeOutAnyway: 'Logga ut mig ändå',
  movedTo: 'Flyttad till',
  nextWeek: 'Nästa vecka',
  nextWeekend: 'Nästa helg',
  noTasksLeft: 'Inga uppgifter kvar!',
  notLoggedIn: 'Ej inloggad',
  offlineMode: 'Nedkopplat läge',
  ok: 'Ok',
  online: 'Uppkopplad',
  openLink: 'Öppna länk',
  password: 'Lösenord',
  profile: 'Profil',
  recurring_day: 'Dagligen',
  recurring_month: 'Månadsvis',
  recurring_week: 'Veckovis',
  recurring_year: 'Årligen',
  save: 'Spara',
  selectAll: 'Välj alla',
  sessionExpired: 'Din session har gått ut',
  signOut: 'Logga ut',
  signup: 'Registrera dig',
  specifyAnExactTime: 'Sätt en exakt tid',
  spreadTheLove: 'Sprid kärleken',
  startAt: 'Nästa tillfälle',
  startByAddingATask: 'Börja med att lägga till en uppgift',
  status_deleted: 'Radera',
  status_done: 'Klar',
  status_postponed: 'Senare',
  status_todo: 'Att göra',
  swipeToComplete: 'Svep för att klarmarkera',
  swipeToPlanForLater: 'Svep för att planera',
  themeSelector: 'Teman',
  thisEvening: 'Ikväll',
  thisWeekend: 'Denna helg',
  tomorrow: 'Imorgon',
  tomorrowEvening: 'Imorgon kväll',
  toTheLeft: 'Svep till vänster',
  toTheRight: 'Svep till höger',
  undo: 'Ångra',
  updated: 'Uppdaterade',
  updatedScheduleTo: 'Uppdaterade vana till',
  whatCanWeDoBetterPleaseLetUsKnow: 'Vad kan vi göra bättre? Berätta vad du tycker!',
  youHaveUnsyncedChangesThatWillBeLost: 'De förändringar som inte hunnits synkas kommer gå förlorade',
  youNeedToLoginAgain: 'Du behöver logga in igen',
  allowLysterCalendarAccess: 'Tillåt Lyster att visa dina kalendrar för att du ska få en så heltäckande bild av dagen som möjligt',
  allowNow: 'Tillåt Nu',
  later: 'Senare',
  calendars: 'Kalendrar',
  nothingPlanned: 'Helt öppet, inget på att göra-listan än!',
  hideUpcoming: 'Visa nuläge',
  showEntireDay: 'Visa hela dagen',
  nextMeetingAt: 'Nästa möte är',
  thingsLaterToday: 'saker senare idag',
  allDoneGoodJob: 'Allt klart, bra jobbat!',
  after: 'Efter',
  refresh: 'Uppdatera',
  empty: 'Inget här än, ditt drag! :)',
  pleaseEnterValidEmail: 'Vänligen fyll i en giltig epost-address',
  pleaseEnter6DigitCodeFromEmail: 'Vänligen fyll i den 6-siffriga koden vi har skickat till dig',
  didntGetTheCodeQuestion: 'Inte fått koden?',
  pleaseTakeAMinuteToReviewAndAccept: 'Vänligen ta en minut för att läsa igenom och acceptera våra användarvillkor och ',
  proceed: 'Fortsätt',
  resendCode: 'Skicka ny kod',
  pleaseReviewAndAcceptOur: 'Vänligen läs och godkänn våra',
  privacyPolicy: 'Integritetspolicy',
  termsOfService: 'Användarvillkor',
  simplyEnterYourEmailAndWellSendYouALink: 'Fyll i din epost så skickar vi en kod till dig. Säkrare och enklare än lösenord.',
  pleaseReviewAndAcceptToProceed: 'Vänligen läs igenom och godkänn för att fortsätta',
  weValueYourPrivacy: 'Vi värdesätter din integritet',
  terms: 'Användarvillkor',
  changedOrder: 'Ändrade sorteringsordning',
  today: 'Idag',
  yesterday: 'Igår',
  last: 'Förra',
  autoDarkMode: 'Automatiskt mörkt läge',
  readingList: 'Läslista',
  automaticallyAddToSafariReadingList: 'Lägg till länkar i Safaris Läslista automatiskt',
  tipReadLaterOffline: 'Tips: Slå på "Spara automatiskt offline" i dina Safari-inställningar för att alla länkar ska vara tillgängliga offline',
  timingSettings: 'Tidsinställningar',
  lysterPremiumComingSoon: 'Lyster Premium kommer snart!',
  premium: 'Premium',
  premiumInfo: 'Snart släpper vi Schedulist! Vi kommer att introducera kategorisering, integrationer och samarbetsmöjligheter samtidigt som vi behåller enkelheten du är van vid från Lyster.',
  startEveningsAt: 'Välj när din kväll börjar',
  startMorningsAt: 'Välj när din morgon börjar',
  pleaseSpecifyATimeBetween: 'Vänligen välj en tid mellan',
};
